export default "__VITE_ASSET__CgVKqb6w__"